import _, { map } from 'underscore';
// const moment = require('moment');
import moment from 'moment';

window._ = _;

window.moment = moment;

const evnt = [];
window.dayEvents = [];
require('clndr');

// restUrl = $('.calendar-widget').data('url') + '/wp-json/wp/v2/event?filter[posts_per_page]=-1';
const baseUrl = $('.calendar-widget').data('url');
const lang = $('.calendar-widget').data('lang');
let restUrl = '';
if (lang === 'de') {
  moment.locale('de');
  restUrl = `${baseUrl}/_evnt-cache/event_${lang}.json`;
} else {
  moment.locale('pt-br');
  restUrl = `${baseUrl}/_evnt-cache/event.json`;
}

$.when(
  $.get(restUrl),
).then(
  (data) => {
    _.each(data, (d) => {
      evnt.push({
        id: d.id,
        title: d.title.rendered,
        date: d.acf.start_date,
        start: d.acf.start_date,
        end: d.acf.end_date,
        location: d.acf.address,
        link: d.link,
        cat: d.category,
      });
    });

    // if (lang == "de") {};
    // moment.locale('pt-br');
    $('#true-clndr').clndr({
      lengthOfTime: {
        // Set to an integer if you want to render one or more months, otherwise
        // leave this null
        months: null,

        // Set to an integer if you want to render one or more days, otherwise
        // leave this null. Setting this to 14 would render a 2-week calendar.
        days: null,

        // This is the amount of months or days that will move forward/back when
        // paging the calendar. With days=17 and interval=7, you would have a
        // 2-week calendar that pages forward and backward 1 week at a time.
        interval: 1,
      },
      multiDayEvents: {
        singleDay: 'date',
        startDate: 'start',
        endDate: 'end',
      },
      daysOfTheWeek: moment.weekdaysShort(),
      template: $('#true-calendar-template').html(),
      events: evnt,
      clickEvents: {
        click(target) {
          if (target.events.length) {
            // console.log($('#single-event').html());
            dayEvents = target.events;
            const eventTemplate = _.template($('#single-event').html());
            const eventsList = $('#true-clndr').find('.events-list');
            // Adiciona o template com as novas variáveis.
            if (dayEvents) {
              eventsList.html(eventTemplate(dayEvents));
            }

            const daysContainer = $('#true-clndr').find('.days-container');
            daysContainer.toggleClass('show-events', true);
            $('#true-clndr').find('.x-button').on('click', () => {
              daysContainer.toggleClass('show-events', false);
            });
          }
        },
      },
      adjacentDaysChangeMonth: false,
      forceSixRows: true,
    });
  },
);
